import { VFC } from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { useUser } from '../hooks/useUser';
import { FLOW_PAGE_TITLE, START_PAGE_TITLE, ACCOUNT_PAGE_TITLE } from '../constants/pageConstants';
import { ReactComponent as HomeIcon } from '../static/home.svg';
import { ReactComponent as UserIcon } from '../static/user.svg';
import { ReactComponent as FlowIcon } from '../static/flow.svg';

const Nav = styled.nav`
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /* padding-bottom: ${props => props.theme.spacing[7]}; */
`;

const NavLinks = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
`;

const activeClassName = 'active';
const StyledNavLink = styled(NavLink)`
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: ${props => props.theme.spacing[3]} ${props => props.theme.spacing[4]};
    gap: ${props => props.theme.spacing[3]};
    text-decoration: none;
    font-size: ${props => props.theme.fontSize[1]};
    font-family: adelle-sans;
    color: ${props => props.theme.colors.gray[6]};
    transition: all .25s ease;
    border-radius: ${props => props.theme.radius.xs};
    line-height: 140%;
    stroke: ${props => props.theme.colors.gray[6]};
    &:hover,
    &:focus,
    &:active {
        color: ${props => props.theme.colors.primary[3]};
        stroke: ${props => props.theme.colors.primary[3]};
    }

    &.${activeClassName} {
        background: ${props => props.theme.colors.primary[0]};
        color: ${props => props.theme.colors.primary[3]};
        stroke: ${props => props.theme.colors.primary[3]};
        font-weight: bold;
    }
`;

const SecondaryNavWrapper = styled.div`
    font-family: adelle-sans;
    font-size: ${props => props.theme.fontSize[0]};
    a {
        color: ${props => props.theme.colors.gray[6]};
        text-decoration: none;
        &:hover {
            text-decoration: underline;
        }
    }
`;

export const Navigation: VFC = () => {
    const { user } = useUser();

    return (
        <Nav role="navigation">
            <NavLinks>
                <li>
                    <StyledNavLink to="/" className={({ isActive }) => isActive ? "active" : ""} title="Startsida">
                        <HomeIcon />
                        {START_PAGE_TITLE}
                    </StyledNavLink>
                </li>
                {user?.hasCustomer && <>
                    <li>
                        <StyledNavLink to="/accounts" className={({ isActive }) => isActive ? "active" : ""} title="Hantera konton för sociala medier">
                            <UserIcon />
                            {ACCOUNT_PAGE_TITLE}
                        </StyledNavLink>
                    </li>
                    <li>
                        <StyledNavLink to="/flows" className={({ isActive }) => isActive ? "active" : ""} title="Hantera anpassade flöden">
                            <FlowIcon />
                            {FLOW_PAGE_TITLE}
                        </StyledNavLink>
                    </li>
                </>}
            </NavLinks>
            <SecondaryNavWrapper>
                <a href="https://www.advania.se/om-advania/integritetsinformation/" target="_blank">
                    Integritetspolicy
                </a>
                <a href="javascript:Didomi.preferences.show()">Hantera kakor</a>
            </SecondaryNavWrapper>
        </Nav>
    );
}
